// axios.js
import axios from 'axios';

const instance = axios.create({
  
  baseURL: 'https://backend.innohubrc.com', // replace with your backend URL
   //baseURL: 'http://localhost:8000', 
});

export default instance;
